import React from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { validateField } from '../../utils/validation/validation';
import InputField from '../../utils/InputField';
import TextAreaField from '../../utils/TextAreaField';
import Dropzone from "../../utils/dropzone";
import PlaceComponent from '../Address/AddressAutoPop';
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper';


function ApplicantForm({ data, onChange, onValidate, errors, isFrom = 'page' }) {
    
    const formatPhoneNumber = (value) => {
        // Remove all non-digit characters
        const phoneNumber = value.replace(/\D/g, '').slice(0, 10); // Limit to 10 digits
        
        // Format as XXX-XXX-XXXX
        if (phoneNumber.length <= 3) {
            return phoneNumber;
        } else if (phoneNumber.length <= 6) {
            return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        } else {
            return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
        }
    };

    const handleChange = (field, value) => {
        let processedValue = value;
        
        // Format phone number
        if (field === 'phoneNumber') {
            processedValue = formatPhoneNumber(value);
        }
        
        onChange(field, processedValue);
        const error = validateField(field, processedValue);  // Validate on field change
        onValidate(field, error);
    };

    const handleFileUpload = (fieldName, uploadedFiles) => {
        console.log('Files uploaded to field:', fieldName, uploadedFiles);
        onChange(fieldName, uploadedFiles); 
    };


    return (
        <Form>
            <Container className="px-0" fluid>
                <Row className="no-gutters">
                    <Col sm={isFrom === 'page' ? 8 : 12 }>
                        <div className={isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }>
                            <div className="form-heading mb-4 text-uppercase fw-bold">Inspection Information</div>
                            <Row className="mb-3">
                                <InputField
                                    field="issuedPermitNumber"
                                    label="Permit Number"
                                    value={data.issuedPermitNumber}
                                    onChange={handleChange}
                                    error={errors.issuedPermitNumber}
                                    type="text"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                            <Row className="mb-3">
                                <InputField
                                    field="name"
                                    label="Contact Name"
                                    value={data.name}
                                    onChange={handleChange}
                                    error={errors.name}
                                    type="text"
                                    as={Col}
                                />
                            </Row>
                            <Row className="mb-3">
                                <GoogleMapsWrapper>
                                    <PlaceComponent
                                        field="address"
                                        label="Address of Inspection"
                                        className="mb-3"
                                        value={data.address}
                                        onChange={handleChange}
                                        type="text"
                                        error={errors.address}
                                    />
                                </GoogleMapsWrapper>
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="phoneNumber"
                                    label="Contact Phone Number"
                                    className="mb-3"
                                    value={data.phoneNumber}
                                    onChange={handleChange}
                                    pattern="^[0-9-]*$"
                                    error={errors.phoneNumber}
                                    type="text"
                                    as={Col}
                                /> 
                            </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="email"
                                    label="Contact Email Address"
                                    value={data.email}
                                    onChange={handleChange}
                                    error={errors.email}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="communityEmailAddress"
                                    label="Community Email Address"
                                    value={data.communityEmailAddress}
                                    onChange={handleChange}
                                    error={errors.communityEmailAddress}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="requestedInspection"
                                    label="Requested Inspection(s)"
                                    value={data.requestedInspection}
                                    onChange={handleChange}
                                    error={errors.requestedInspection}
                                    type="text"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                        </div>
                    </Col>
                    <Col sm={isFrom === 'page' ? 4 : 12 }>
                        <div className="{isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }">
                            <TextAreaField
                                field="comments"
                                label="Comment Area"
                                value={data.comments}
                                onChange={handleChange}
                                error={errors.comments}
                                as={Col}
                            />
                            <div className="form-heading mt-5 text-uppercase fw-bold">
                                Upload Files <span className="text-danger">*</span>
                            </div>
                            <div className="form-heading">
                                Image or Video file types are permitted
                            </div>
                            <Dropzone
                                fileTypes={['image/*', 'video/*']}
                                showPreview={true}
                                fieldName="files"
                                onFileUpload={handleFileUpload}
                                maxFileSizeMB={250}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
}

export default ApplicantForm;